import clsx from 'clsx';
import { Product } from '@la/types';
import { useRegistrationAddOns } from 'redux/hooks/useRegistrationAddOns';
import { selectSelectionsWithErrors } from 'redux/selectors/registrationAddOnsSelectors';
import { useAppSelector } from 'redux/store';
import { extractFeeRange } from '../../Tournaments/TournamentDetailsPage/utils/feeCalculationUtils';
import { CardDisplayType } from '../MemberRegistration.types';
import styles from './AddOnCard.module.scss';
import AddOnDescription from './AddOnDescription';
import AddOnPriceRange from './AddOnPriceRange';
import AddOnProductImage from './AddOnProductImage';
import AddOnSelections from './AddOnSelections';

export function RequiredAddOnCard({
  addOnData,
  cardDisplayType,
}: Readonly<{ addOnData: Product; cardDisplayType: CardDisplayType }>) {
  const { description, id, name, imageRef } = addOnData;
  const {
    getSelectedProduct,
    updateRequiredAddOnSelection,
    getUserSelectionsByAddOnId,
    removeSelectionWithError,
  } = useRegistrationAddOns();

  const { maxFee, minFee } = extractFeeRange(addOnData);
  const selectionsWithErrors = useAppSelector(selectSelectionsWithErrors);
  const selectedProductPrice = getSelectedProduct(addOnData.id)?.subTotal;

  const cardStyle = clsx(styles.addOnCard, styles[cardDisplayType]);

  return (
    <div className={cardStyle}>
      <AddOnProductImage imageRef={imageRef} name={name} />
      <span className={styles.labelAndPricing}>
        <span className={styles.label}>{name}</span>
        <AddOnPriceRange
          maxFee={maxFee}
          minFee={minFee}
          salesTaxRequired={addOnData.salesTaxRequired}
          selectedProductPrice={selectedProductPrice}
        />
      </span>
      <AddOnDescription description={description} />
      <AddOnSelections
        cardDisplayType={cardDisplayType}
        productId={id}
        properties={addOnData.properties}
        selectionsWithErrors={selectionsWithErrors}
        updateAddOnSelection={updateRequiredAddOnSelection}
        userSelections={getUserSelectionsByAddOnId(addOnData.id)}
        clearSelectionError={removeSelectionWithError}
      />
    </div>
  );
}
